var React = require('react');

function TriangleMktngContact (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M83.8799 86.6574L72.4011 23.9666L158.737 73.5604L83.8799 86.6574Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M35.3163 124.217L72.4821 23.9006L83.9173 86.5181L35.3163 124.217Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M35.3203 124.217L83.8871 86.544L158.74 73.5576L35.3203 124.217Z","fill":"#5915C7","key":2})]);
}

TriangleMktngContact.defaultProps = {"width":"159","height":"153","viewBox":"0 0 159 153","fill":"none"};

module.exports = TriangleMktngContact;

TriangleMktngContact.default = TriangleMktngContact;
